import Assign from './Assign/Assign';
import UpdateCell from './UpdateCell/UpdateCell';
import DeleteColumn from './DeleteColumn/DeleteColumn';
import DeleteRow from './DeleteRow/DeleteRow';
import Duplicate from './Duplicate/Duplicate';
import GetColumn from './GetColumn/GetColumn';
import InsertColumn from './InsertColumn/InsertColumn';
import InsertRow from './InsertRow/InsertRow';
import Join from './Join/Join';
import Merge from './Merge/Merge';
import Length from './Length/Length';
import { types } from './types';

function Actions(action, showAlert, variables, setOpenVariable) {
    if (action.actionName === types.ASSIGN) {
        return <Assign action={action} showAlert={showAlert} variables={variables} setOpenVariable={setOpenVariable} />;
    } else if (action.actionName === types.DELCOLUMN) {
        return <DeleteColumn action={action} showAlert={showAlert} variables={variables} setOpenVariable={setOpenVariable} />;
    } else if (action.actionName === types.DELROW) {
        return <DeleteRow action={action} showAlert={showAlert} variables={variables} setOpenVariable={setOpenVariable} />;
    } else if (action.actionName === types.INSERTROW) {
        return <InsertRow action={action} showAlert={showAlert} variables={variables} setOpenVariable={setOpenVariable} />;
    } else if (action.actionName === types.INSERTCOLUMN) {
        return <InsertColumn action={action} showAlert={showAlert} variables={variables} setOpenVariable={setOpenVariable} />;
    } else if (action.actionName === types.JOIN) {
        return <Join action={action} showAlert={showAlert} variables={variables} setOpenVariable={setOpenVariable} />;
    } else if (action.actionName === types.MERGE) {
        return <Merge action={action} showAlert={showAlert} variables={variables} setOpenVariable={setOpenVariable} />;
    } else if (action.actionName === types.DUPLICATE) {
        return <Duplicate action={action} showAlert={showAlert} variables={variables} setOpenVariable={setOpenVariable} />;
    } else if (action.actionName === types.GETCOLUMN) {
        return <GetColumn action={action} showAlert={showAlert} variables={variables} setOpenVariable={setOpenVariable} />;
    } else if (action.actionName === types.UPDATECELL) {
        return <UpdateCell action={action} showAlert={showAlert} variables={variables} setOpenVariable={setOpenVariable} />;
    } else if (action.actionName === types.LENGTH) {
        return <Length action={action} showAlert={showAlert} variables={variables} setOpenVariable={setOpenVariable} />;
    }
}
export default Actions;
